/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";

import to from "await-to-js";
import { updatePaymentBillingAddress } from "@/app/csr-src/apis/checkout/checkout.api";
import { PAY_TYPE } from "@/app/csr-src/apis/checkout/constants/constants";

import {
  Radio,
  IconButton,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Box,
  Checkbox,
  Divider,
} from "@mui/material";
import UKImg from "@/common-components-src/components/UKImg";
import UKToast from "@/common-components-src/components/UKToast/index";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import UKTruncatedTooltip from "@/common-components-src/components/UKTruncatedTooltip";
import NewOrEditAddress from "@/common-components-src/js/address/addressCreate";

import CreditCardForm from "../components/creditCardForm";

import CloseIcon from "@mui/icons-material/Close";
import ArrowRight from "@/app/csr-src/assets/icons/ArrowRight.svg";
import TipIcon from "@/app/csr-src/assets/icons/TipIcon.svg";
import PAGE_TYPE from "@/common-components-src/js/address/const/pageType";

import cn from "clsx";
import Styles from "./paymentListCard.module.scss";
import { IPaymentVo } from "@/app/csr-src/apis/checkout/checkout.interface";

interface PaymentListCardProps {
  isHideTitle?: boolean;
  className?: string;
  onTrack: (payment: any) => void;
  onFresh: (params?: any) => void;
}

/**
 * 修改支付相关的信息 
 * 
 * */
const CHANGE_PAYMENT_TYPE = {
  //修改支付方式
  CHANGE_PAYMENT: "CHANGE_PAYMENT",
  //修改支付账号
  CHANGE_ACCOUNT: "CHANGE_ACCOUNT",
  //删除支付账号
  // DELETE_ACCOUNT: "DELETE_ACCOUNT",
  // 添加新账号
  ADD_ACCOUNT: "ADD_ACCOUNT",
  // 用户选择是否记住账号
  REMEMBER_ACCOUNT: "REMEMBER_ACCOUNT"
}

const PaymentListCard = observer((props: PaymentListCardProps) => {
  const { t } = useTranslation();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [payTipDialogVisible, setPayTipDialogVisible] = useState(false);
  const [currentPaymentIndex, setCurrentPaymentIndex] = useState(0);
  const [rememberTipVisible, setRememberTipVisible] = useState(false);
  const [rememberConfirmVisible, setRememberConfirmVisible] = useState(false);
  const [payTipInfo, setPayTipInfo] = useState({
    title: "",
    content: "",
  });
  const { checkoutStore } = useStores();
  const { creditCardStore } = checkoutStore;
  const { setBillingAddress } = creditCardStore;

  const getUpdateAddress = async (address: any) => {
    const requestData = {
      ...address,
      billId: (creditCardStore.billingAddress as any).billId,
    };
    const [err, res] = await to(updatePaymentBillingAddress(requestData));

    if (!err && res.success) {
      setBillingAddress({ ...res.data });
      setOpenCreateModal(false);
      return;
    }

    UKToast.show({
      content: res?.msg || t("common.message.networkError"), // 弹窗内容
      icon: "error", // 可选：success, fail, loading, warn, info，影响图标
    });
  };
  // 切换支付方式
  const changePayment = (index: number, payment: IPaymentVo) => {
    setCurrentPaymentIndex(index);
    props.onTrack({
      payWay: String(payment.payToolId),
      channelName: payment.payEnum,
    });


    const paymentListTmp = getPaymentList(index, CHANGE_PAYMENT_TYPE.CHANGE_PAYMENT);

    props.onFresh && props.onFresh({
      disabledPayMethods: checkoutStore.disabledPayMethods.join(","),
      currentUserPayMethods: JSON.stringify([
        ...paymentListTmp
      ])
    })
  };

  // 切换支付账号方式
  const changePaymentAccount = (
    paymentInfoInfo: {
      // paymentIndex: number,
      accountIndex: number,
      type?: string,
    }) => {
    const paymentListTmp = getPaymentList(paymentInfoInfo.accountIndex, paymentInfoInfo.type || CHANGE_PAYMENT_TYPE.CHANGE_ACCOUNT);
    console.log(paymentListTmp, currentPaymentIndex, "paymentListTmp");

    props.onFresh && props.onFresh({
      disabledPayMethods: checkoutStore.disabledPayMethods.join(","),
      currentUserPayMethods: JSON.stringify([
        ...paymentListTmp
      ])
    });
  };

  // 是否记住账号
  const changeRememberAccount = () => {
    let paymentTmp = (checkoutStore.paymentList as any)[currentPaymentIndex];
    paymentTmp = JSON.parse(JSON.stringify(paymentTmp));
    paymentTmp.rememberInfo.rememberCheckbox = !(paymentTmp.rememberInfo.rememberCheckbox);

    const paymentListTmp = getPaymentList(currentPaymentIndex, CHANGE_PAYMENT_TYPE.REMEMBER_ACCOUNT, JSON.parse(JSON.stringify(paymentTmp)));

    props.onFresh && props.onFresh({
      disabledPayMethods: checkoutStore.disabledPayMethods.join(","),
      currentUserPayMethods: JSON.stringify([
        ...paymentListTmp
      ])
    });
  };

  /**
 * 
 * @param accountIndex 当前支付账号的索引
 * @param type  当前操作类型
 * @returns 处理后的支付信息
 */
  const getPaymentList = (actionIndex: number, type: string, payment?: IPaymentVo) => {
    const paymentListTmp = JSON.parse(JSON.stringify(checkoutStore.paymentList));
    const paymentTmp = paymentListTmp[currentPaymentIndex];


    switch (type) {
      /**
       * 
       * 切换支付方式
       * 1、遍历paymentListTmp，将所有selected重置为false
       * 2、将当前选中支付方式的selected设置为true
       * 
       */
      case CHANGE_PAYMENT_TYPE.CHANGE_PAYMENT:
        paymentListTmp.map((item: IPaymentVo, index: number) => {
          if (index === actionIndex) {
            item.selected = true;
          } else {
            item.selected = false;
          }
          return item;
        })
        break;
      /**
       * 
       * 切换账号
       * 1、useNewAccount使用新账号重置为false
       * 2、遍历paymentAccountList，将所有checked重置为false
       * 3、将当前选中账号的checked设置为true
       * 4、将paymentListTmp的当前支付方式中的信息替换为新的paymentTmp
       * 
       */
      case CHANGE_PAYMENT_TYPE.CHANGE_ACCOUNT:
        paymentTmp.rememberInfo.useNewAccount = false;
        paymentTmp.paymentAccountList.map((item: any) => {
          item.checked = false;
          return item;
        })
        const accountTmp = paymentTmp.paymentAccountList?.[actionIndex];
        paymentTmp.paymentAccountList?.splice(
          actionIndex, 1,
          {
            ...accountTmp,
            checked: true,
          }
        );
        paymentListTmp.splice(
          currentPaymentIndex, 1,
          paymentTmp
        );
        break;
      /**
       * 
       * 删除账号 PC暂时没有
       * 1、将paymentListTmp的当前支付方式中的paymentAccountList的当前账号删除
       * 2、将paymentListTmp的当前支付方式中的信息替换为新的paymentTmp
       * 
       */
      // case CHANGE_PAYMENT_TYPE.DELETE_ACCOUNT:
      //   paymentTmp.paymentAccountList?.splice(
      //     actionIndex, 1);

      //   paymentListTmp.splice(
      //     currentPaymentIndex, 1,
      //     paymentTmp
      //   );
      //   break;
      /**
       * 新增账号
       * 1、将paymentListTmp的当前支付方式中的使用新账号字段勾选rememberInfo.useNewAccount
       * 2、将paymentListTmp的当前支付方式中的paymentAccountList的中账号的checked重置为false
       * 3、将paymentListTmp的当前支付方式中的信息替换为新的paymentTmp
       * 
       */
      case CHANGE_PAYMENT_TYPE.ADD_ACCOUNT:
        paymentTmp.rememberInfo.useNewAccount = true;
        paymentTmp.rememberInfo.rememberCheckbox = true;
        paymentTmp.paymentAccountList.map((item: any) => {
          item.checked = false;
          return item;
        })
        console.log(paymentListTmp, "paymentListTmp---add");

        paymentListTmp.splice(
          currentPaymentIndex, 1,
          paymentTmp
        );
        break;
      /**
       * 切换记住账号功能
       * 将当前支付方式中的rememberInfo字段中的rememberCheckbox字段设置为true或false
       * 
       */
      case CHANGE_PAYMENT_TYPE.REMEMBER_ACCOUNT:
        console.log(payment, currentPaymentIndex, 'paymentListTmp----RemenberAccount');

        paymentListTmp.splice(
          currentPaymentIndex, 1,
          payment
        );
        break
      default:
        break;
    }

    return paymentListTmp.map((item: IPaymentVo) => {
      return {
        payMethod: item.payToolId,
        checked: item.selected,
        rememberInfos: item.isOpenFastPay ? {
          useNewAccount: item.rememberInfo?.useNewAccount,
          rememberCheckbox: item.rememberInfo?.rememberCheckbox,
          accountList: item.paymentAccountList
        } : null
      }
    })
  }

  useEffect(() => {
    const initIndex = checkoutStore.paymentList?.findIndex((item: any) => item.selected);
    setCurrentPaymentIndex(initIndex)
  }, [checkoutStore.paymentList])

  return (
    <div className={cn(Styles.paymentListCardBox, props.className)}>
      {!props.isHideTitle && <div className={Styles.title}>{t("checkout.payMethod.title")}</div>}
      <div className={Styles.content}>
        {checkoutStore.paymentList.map((payment: any, index) => {
          return (
            <div key={"payment_" + index}>
              <div className={Styles.paymentItemBox}>
                <div className={Styles.paymentItemFirst}>
                  <div
                    className={cn(Styles.leftBox, {
                      [Styles.paymentDisabled]: !payment.enabled,
                    })}
                    onClick={() => {
                      !payment.enabled || payment.selected ? null : changePayment(index, payment);
                    }}
                  >
                    <Radio
                      checked={payment.selected}
                      className={Styles.radio}
                      disabled={!payment.enabled}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 20,
                        },
                      }}
                    />
                    <div className={Styles.payInfoBox}>
                      <div className={Styles.imageBox}>
                        <UKImg
                          url={payment.iconUrl}
                          externalMaskStyles={{ background: "rgba(0, 0, 0, 0)" }}
                        />
                      </div>
                      <div>{payment.payToolName}</div>
                      {payment.prompt && (
                        <TipIcon
                          width={20}
                          style={{ marginLeft: "2px", marginTop: "2px", cursor: "pointer" }}
                          onClick={(e) => {
                            setPayTipInfo(payment.prompt);
                            setPayTipDialogVisible(true);
                            e.stopPropagation();
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {Number(payment.payToolId) === PAY_TYPE.CREDIT_CARD && (
                    <div className={Styles.rightBox}>
                      {payment.supportBrands?.map((brand: string, index: number) => {
                        return (
                          <div className={Styles.cardImage} key={"brand_" + index}>
                            <UKImg
                              url={brand}
                              externalMaskStyles={{ background: "rgba(0, 0, 0, 0)" }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
                {/* 提示文案 */}
                {payment.tips?.length ? (
                  <div className={Styles.paymentItemSecond}>
                    {payment.tips.map((item: any, index: number) => {
                      return (
                        <span
                          key={"tips_" + index}
                          style={{
                            color: item.color,
                            fontSize: item.size + "px",
                            lineHeight: item.lineHeight + "px",
                            fontFamily: item.family,
                            fontWeight: item.weight === "bold" ? 700 : 400,
                          }}
                        >
                          {item.text}
                        </span>
                      );
                    })}
                  </div>
                ) : null}
                {/* 记住支付账号相关信息 */}
                {Number(payment.payToolId) === checkoutStore.payMethod &&
                  (payment.rememberInfo?.addNewAccountTitle || !payment.isOpenFastPay) && (
                    <div className={Styles.paymentAccountInfoBox}>
                      <div className={Styles.accountListbox}>
                        {payment.paymentAccountList?.map((account: any, i: number) => {
                          return (
                            <div
                              className={Styles.accountItem}
                              key={ Math.random() + "account_" + i}
                              onClick={() => {

                                if (!account.checked) {
                                  // setCurrentPaymentIndex(index);
                                  changePaymentAccount({ accountIndex: i })
                                }
                              }}
                            >
                              <div className={Styles.titleBox}>
                                <Radio
                                  checked={account.checked}
                                  className={Styles.radio}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      fontSize: 16,
                                    },
                                  }}
                                />
                                {
                                  account.brandLogo && <div className={Styles.brandLogoBox}>
                                    <UKImg
                                      url={account.brandLogo}
                                      externalMaskStyles={{ background: "rgba(0, 0, 0, 0)" }}
                                    />
                                  </div>
                                }
                                {account.accountName}
                              </div>
                            </div>
                          );
                        })}

                        {/* 记住账号 */}
                        <div className={Styles.accountItem}>
                          {payment.paymentAccountList.length > 0 && (
                            <div
                              className={Styles.titleBox}
                              onClick={() => {
                                if (!payment.rememberInfo.useNewAccount) {
                                  changePaymentAccount({ accountIndex: -1, type: CHANGE_PAYMENT_TYPE.ADD_ACCOUNT })
                                }
                              }}
                            >
                              <Radio
                                checked={payment.rememberInfo.useNewAccount}
                                className={Styles.radio}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 16,
                                  },
                                }}
                              />
                              {payment.rememberInfo.addNewAccountTitle}
                            </div>
                          )}
                          {/* 如果网关是BNP，且支付方式是PAYMENT, 则显示form表单 */}
                          {Number(payment.payToolId) === PAY_TYPE.CREDIT_CARD &&
                            (payment.rememberInfo.useNewAccount || !payment.isOpenFastPay) && <div style={{
                              marginLeft: payment.paymentAccountList.length > 0 ? "24px" : "0px"
                            }}>
                              <CreditCardForm />
                            </div>}

                          {payment.rememberInfo.useNewAccount && (
                            <div
                              className={Styles.contentBox}
                              style={{
                                marginLeft: payment.paymentAccountList.length > 0 ? "24px" : "0px",
                              }}
                            >
                              <div className={Styles.firstBox} onClick={() => {
                                if (Number(payment.payToolId) === PAY_TYPE.CREDIT_CARD && payment.rememberInfo.rememberCheckbox) {
                                  setRememberConfirmVisible(true)
                                } else {
                                  changeRememberAccount();
                                }
                              }}>
                                <Checkbox
                                  checked={payment.rememberInfo.rememberCheckbox}
                                  className={Styles.checkbox}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      fontSize: 16,
                                      borderRadius: 4,
                                    },
                                  }}
                                />
                                <div>{payment.rememberInfo.rememberCheckboxTitle}</div>
                                {
                                  Number(payment.payToolId) === PAY_TYPE.CREDIT_CARD && < TipIcon
                                    width={20}
                                    style={{ marginTop: "2px", marginLeft: "4px", cursor: "pointer" }}
                                    onClick={(e: any) => {
                                      setRememberTipVisible(true)
                                      e.stopPropagation()
                                    }}
                                  />
                                }
                              </div>
                              {payment.rememberInfo.rememberAccountTips && (
                                <>
                                  <Divider />
                                  <div className={Styles.secondBox}>
                                    {payment.rememberInfo.rememberAccountTips}
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                          {Number(payment.payToolId) === PAY_TYPE.CREDIT_CARD &&
                            checkoutStore.isBnpCreditCardForm &&
                            (creditCardStore.billingAddress as any).name &&
                            (creditCardStore.billingAddress as any).fullAddress && (
                              <div className={Styles.paymentBillingAddressBox} style={{
                                marginLeft: payment.paymentAccountList.length > 0 ? "24px" : "0px"
                              }}>
                                <div className={Styles.title}>Billing Address</div>
                                <div className={Styles.detail} onClick={() => setOpenCreateModal(true)}>
                                  <UKTruncatedTooltip
                                    text={
                                      (creditCardStore.billingAddress as any).name +
                                      ", " +
                                      (creditCardStore.billingAddress as any).fullAddress
                                    }
                                    tooltipStyles={Styles.left}
                                    tooltipProps={{
                                      placement: "top",
                                      arrow: true,
                                    }}
                                  />
                                  <ArrowRight width={16} style={{ color: "#888B94" }} />
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          );
        })}
      </div>
      {/* 信用卡 billingAddress */}
      <UKDialog
        open={openCreateModal}
        onClose={() => setOpenCreateModal(false)}
        showCloseBtn={true}
        sx={{
          "& .MuiDialog-paper": {
            width: "880px", // 设置自定义宽度
            maxWidth: "none", // 取消最大宽度限制
            maxHeight: "534px",
            minHeight: "334px",
          },
        }}
      >
        <IconButton
          aria-label="close"
          onClick={() => setOpenCreateModal(false)}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <NewOrEditAddress
            isHiddenSetDefault={true}
            isModal={true}
            isEdit={true}
            data={creditCardStore.billingAddress}
            getUpdateAddress={getUpdateAddress}
            isCashierEntry={true}
            pageType={PAGE_TYPE.BILLING}
          />
        </DialogContent>
      </UKDialog>
      {/* 支付tip提示 */}
      <UKDialog
        open={payTipDialogVisible}
        onClose={() => setPayTipDialogVisible(false)}
        showCloseBtn={true}
        sx={{
          "& .MuiDialog-paper": {
            width: "380px", // 设置自定义宽度
            maxWidth: "none", // 取消最大宽度限制
          },
        }}
      >
        <DialogTitle>{payTipInfo.title}</DialogTitle>

        {/* Error info */}
        <DialogContent>
          <Box className={Styles.payTipDialogContent}>{payTipInfo.content}</Box>
        </DialogContent>

        {/* Button */}
        <DialogActions>
          <Button onClick={() => setPayTipDialogVisible(false)} size="small" variant="contained">
            {t("common.btnText.ok")}
          </Button>
        </DialogActions>
      </UKDialog>

      <UKDialog
        open={rememberTipVisible}
        onClose={() => setRememberTipVisible(false)}
        showCloseBtn={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "380px", // 设置自定义宽度
            maxWidth: "none", // 取消最大宽度限制
          },
        }}
      >
        <DialogContent>
          <Box className={Styles.payTipDialogContent}>
            {t("checkout.paymentDetail.promise")}
          </Box>
        </DialogContent>

        {/* Button */}
        <DialogActions>
          <Button onClick={() => setRememberTipVisible(false)} size="small" variant="contained">
            {t("common.btnText.ok")}
          </Button>
        </DialogActions>
      </UKDialog>

      {/* 切换记住账号confirm */}
      <UKDialog
        open={rememberConfirmVisible}
        onClose={() => setRememberConfirmVisible(false)}
        showCloseBtn={true}
        sx={{
          "& .MuiDialog-paper": {
            width: "380px", // 设置自定义宽度
            maxWidth: "none", // 取消最大宽度限制
          },
        }}
      >
        <DialogTitle>{t("checkout.tips.rememberMyCard")}</DialogTitle>

        {/* Error info */}
        <DialogContent>
          <Box className={Styles.payTipDialogContent}>
            {t("checkout.paymentDetail.promise")}
          </Box>
        </DialogContent>

        {/* Button */}
        <DialogActions>
          <Button
            onClick={() => {
              setRememberConfirmVisible(false);
              changeRememberAccount();
            }}
            size="small" variant="outlined">
              {t("checkout.paymentDetail.forgetCard")}
          </Button>
          <Button
            onClick={() => {
              setRememberConfirmVisible(false);
            }}
            size="small" variant="contained">
              {t("checkout.paymentDetail.rememberCard")}
          </Button>
        </DialogActions>
      </UKDialog>
    </div >
  );
});

export default PaymentListCard;
